import { InjectionToken } from '@angular/core';

import { BaasTelemetry, BarCacheStore } from '@lvflanders/bar';

// injection token to have same class injected in different ways
export const BAR_GLOBAL_CACHE = new InjectionToken<BarCacheStore>('Global cache store');
export const BAR_USER_CACHE = new InjectionToken<BarCacheStore>('User cache store');
export const BAR_APP_CACHE = new InjectionToken<BarCacheStore>('Application cache store');
export const BAR_MELDINGEN_CACHE = new InjectionToken<BarCacheStore>('Meldingen cache store');
/** Token used to define whether running under localhost. */
export const BAR_LOCALHOST = new InjectionToken<boolean>('BAR localhost token');
/** Token for Telemetry service. */
export const BAAS_TELEMETRY = new InjectionToken<BaasTelemetry>('BaaS Telemetry service');
